module.exports = __webpack_public_path__ + "png/straight.png?a67869eaa6cb6dd52ffc93c66541229f";